import * as React from 'react';
import './TrialFormPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { Column, RowInfo } from 'react-table';
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import { ITrialFormReduxFormState, initialTrialFormState } from "../../../reducers/reactReduxForms/trialForm";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, DatePickerFormInputFabric, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as TrialFormActions from '../../../actions/trialForm';
import * as TrialActions from '../../../actions/trial';
import * as TrialFormsPageActions from '../../../actions/pages/trialFormsPage';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TrialLayout } from '../../index';
import * as FormHelper from '../../../helpers/formHelper';

import {
    CollectionInstancePage
} from "../../../containers/index";

interface ITrialFormPageParams {
    trialId: number;
    trialFormId: number;
}

interface ITrialFormPageProps {

    form: Dtos.TrialForm & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialFormReduxFormState;

    location: Location;
    trialId: number;
    trialFormId: number;
    match: match<ITrialFormPageParams>;
    history: History;

    // modals
    modalTitle: string,
    modalDescription: string,
    editModalOpen: boolean,
    collectionInstanceId: number,
    createVersionModalOpen: boolean,

    // From state
    trialForm: Dtos.TrialForm;
    trial: Dtos.Trial;
    lookups: Dtos.Lookup[];

    loadingTrial: boolean;

    loadingTrialForm: boolean;
    loadTrialFormSuccess: boolean;
    loadTrialFormFailure: boolean;

    savingTrialForm: boolean;
    saveTrialFormSuccess: boolean;
    saveTrialFormFailure: boolean;

    creatingTrialForm: boolean;
    createTrialFormSuccess: boolean;
    createTrialFormFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ITrialFormPageActions {
    clearTrialForm: TrialFormActions.ITrialFormClearActionCreator;
    loadTrialForm: TrialFormActions.ITrialFormLoadByIdActionCreator;
    saveTrialForm: TrialFormActions.ITrialFormSaveActionCreator;
    createTrialForm: TrialFormActions.ITrialFormCreateActionCreator;
    sendReminderEmailTrialForm: TrialFormActions.ITrialFormSendReminderEmailActionCreator;

    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setEditModelViewState: TrialFormsPageActions.ITrialFormsPageSetEditModalViewStateActionCreator;
    setCreateVersionModelViewState: TrialFormsPageActions.ITrialFormsPageSetCreateVersionModalViewStateActionCreator;

}

type TrialFormPageProps = ITrialFormPageProps & ITrialFormPageActions;

const reduxFormName: string = "reduxForms.trialForm";

class TrialFormPage extends React.PureComponent<TrialFormPageProps, any> {

    constructor(props: TrialFormPageProps) {
        super(props);

        this.clearTrialForm = this.clearTrialForm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadTrialForm,
            createTrialForm,
            trialFormId,
            trialId,
            loadTrial
        } = this.props;

        if (trialFormId) {
            loadTrialForm(trialFormId);
        } else if (!trialFormId) {
            createTrialForm(trialId, 0, 0);
        }
        loadTrial(trialId, false, true, false, false, false);
    }

    componentDidUpdate(prevProps: TrialFormPageProps, prevState) {
        const {
            form,
            trialId,
            trialFormId,
            trialForm,
            loadTrialForm,
            loadTrial,
            loadingTrialForm,
            loadTrialFormSuccess,
            savingTrialForm,
            saveTrialFormSuccess,
            createTrialForm,
            validationFailures,
            creatingTrialForm,
            createTrialFormSuccess,
            navigate
        } = this.props;

        if (trialId && prevProps.trialId != trialId) {
            loadTrial(trialId, false, true, false, false, false);
        }

        if (trialFormId && prevProps.trialFormId != trialFormId) {
            loadTrialForm(trialFormId);
        }
        else if (!trialFormId && prevProps.trialFormId) {
            createTrialForm(trialId, 0, 0);
        }

        if (!loadingTrialForm && prevProps.loadingTrialForm) {
            if (loadTrialFormSuccess) {
                this.loadForm();
            }
            else {

            }
        }


        if (!savingTrialForm && prevProps.savingTrialForm) {
            if (saveTrialFormSuccess) {
                if (validationFailures && validationFailures.length > 0) {

                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                    // toggleMessageModal();

                } else {

                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);

                }
                if (form.saveAndReturn) {
                    navigate("/trials/" + trialId + "/forms")
                } else if (!form.saveAndReturn && trialFormId && trialFormId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !trialFormId && trialForm && trialForm.id > 0) {
                    navigate("/trials/" + trialId + "/forms/" + trialForm.id);
                    this.loadForm();
                }
            }
            else {

                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );

            }
        }

        if (!creatingTrialForm && prevProps.creatingTrialForm) {
            if (createTrialFormSuccess) {
                this.loadForm();
            }
            else {

            }
        }
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearTrialForm();
        loadForm(reduxFormName, initialTrialFormState);
        resetForm(reduxFormName);
    }

    clearTrialForm() {
        this.props.clearTrialForm();
        this.props.clearTrial();
    }

    showTrialForm(): boolean {
        const {
            loadingTrial,
            loadingTrialForm,
            loadTrialFormSuccess
        } = this.props

        if (!loadingTrial && !loadingTrialForm && loadTrialFormSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingTrial,
            loadingTrialForm,
        } = this.props;

        return <TrialLayout loading={loadingTrial || loadingTrialForm} permission={Dtos.Permission.TrialFormView}>
            {this.renderContent()}
            {this.renderItemModal()}
        </TrialLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingTrialForm,
            permissions,
            sendReminderEmailTrialForm
        } = this.props;

        let noPermissionToEditMessage = false;
        if ((form.id && form.id > 0) && validationFailures && validationFailures.filter(f => f.errorCode == "PR-005").length > 0) {
            noPermissionToEditMessage = true;
        }

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialFormUpdate, Dtos.Permission.TrialFormCreate);
        const formNew: boolean = FormHelper.isNew(formState, form);

        const formDisabled: boolean = !hasPermission || savingTrialForm || (formState && formState.formStatus == Dtos.FormStatus.Disabled) || noPermissionToEditMessage;


        let formComponents: { [index: string]: RegistrationFormComponent } = {
            institution: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    institutionId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: !formNew,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "InstutitionId", lookups), form.institutionId)
                        },
                        size: 1
                    },
                },
                hide: formNew
            },
            formTemplate: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    formTemplateId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: !formNew,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "FormTemplateId", lookups), form.formTemplateId)
                        },
                        size: 1
                    },
                }
            },
            patientStatus: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    patientId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled || !formNew,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "PatientId", lookups), form.patientId)
                        },
                        size: 2
                    },
                    formStatusId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "FormStatusId", lookups), form.formStatusId)
                        },
                        size: 2,
                        hide: formNew
                    }
                }
            },
            assign: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    assignmentTypeId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "AssignmentTypeId", lookups), form.assignmentTypeId)
                        },
                        changeAction: (model, value, form, parentModel) => {
                            changeForm(model, value);
                            //debugger;
                            if (value && value == 1) {
                                changeForm(reduxFormName + parentModel + '.assignedToId', null);
                            } else if (value && value == 2) {
                                changeForm(reduxFormName + parentModel + '.assignedRoleId', null);
                            } else {
                                changeForm(reduxFormName + parentModel + '.assignedToId', null);
                                changeForm(reduxFormName + parentModel + '.assignedRoleId', null);
                            }
                        },
                        size: 2
                    },
                    assignedToId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "AssignedToId", lookups), form.assignedToId)
                        },
                        changeAction: (model, value, form, parentModel) => {
                            changeForm(model, value);
                            changeForm(reduxFormName + parentModel + '.assignedTo', null);
                            changeForm(reduxFormName + parentModel + '.assignedRole', null);
                        },
                        size: 2,
                        hide: form.assignmentTypeId != 2
                    },
                    assignedRoleId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "AssignedRoleId", lookups), form.assignedRoleId)
                        },
                        changeAction: (model, value, form, parentModel) => {
                            changeForm(model, value);
                            changeForm(reduxFormName + parentModel + '.assignedTo', null);
                            changeForm(reduxFormName + parentModel + '.assignedRole', null);
                        },
                        size: 2,
                        hide: form.assignmentTypeId != 1
                    },
                }
            },
            currentVersion: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    version: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled || !formNew,
                        size: 2
                    }
                }
            },
            nextVersion: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    formNextAutoVersionId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(findLookup("TrialForm", "FormNextAutoVersionId", lookups))
                        },
                        size: 2
                    },
                    dateNextVersion: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: DatePickerFormInputFabric,
                        validationMessageAbove: true,
                        inputDisabled: formDisabled,
                        size: 2
                    },
                }
            }
        };

        return <div>
            <div className="row">
                <div className={"col mb-2"}>
                    <h3>Trial Form</h3>
                </div>
                <div className={"col-auto pr-0"}>
                    <Link className={"btn btn-secondary"} url={"/trials/" + form.trialId + '/forms/' + form.id + '/report'}>Report</Link>
                </div>
                <div className="col-auto">
                    <button type="button" className="btn btn-secondary mr-3" onClick={() => sendReminderEmailTrialForm(form.id)}>
                        Reminder Email
                    </button>
                    <button disabled={formNew || !this.showTrialForm()}
                        onClick={
                            () => {
                                const url: string = "/trials/" + form.trialId + "/forms/" + form.id + "/entry";
                                this.props.navigate(url);
                            }
                        }
                        type="submit"
                        className="btn btn-warning mr-0"
                    >
                        {!AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialFormUpdate, Dtos.Permission.TrialFormCreate) ? "View Data" : "Enter Data"}
                    </button>
                </div>
            </div>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "trialForm", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                {(!formNew) && this.renderVersionsTable()}

                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>
        </div>

    }

    renderVersionsTable() {
        const {
            form,
            setEditModelViewState,
            permissions
        } = this.props

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialFormUpdate, Dtos.Permission.TrialFormCreate);

        if (!form || !form.versions || form.versions.length == 0) {
            return <div className="alert alert-info d-flex mt-3">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no old versions</span>
            </div>
        }

        const showPagination = false;

        return <>
            <div className="border-0 d-flex pt-4 ">
                <h3>Versions</h3>
            </div>
            <div className="table-wrapper mb-3">
                <ReactTable
                    data={form.versions}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : form.versions.length}
                    pageSize={showPagination ? undefined : form.versions.length}
                    showPagination={showPagination}
                    className="-striped -highlight -clickable mb-3"
                    noDataText="There are currently no versions to display"
                    resizable={false}
                    getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                        return {
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    columns={[
                        {
                            id: "id",
                            Header: ' ',
                            accessor: "id",
                            className: "d-flex align-items-center justify-content-center",
                            maxWidth: 50,
                            Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Regular.CLOCK} fixedWidth />
                        },
                        {
                            id: "assignedToId",
                            Header: 'Assigned To',
                            accessor: 'assignedTo.display',
                            className: "d-flex align-items-center justify-content-center"
                        },
                        {
                            id: "formStatusId",
                            Header: 'Status',
                            accessor: 'formStatus.name',
                            className: "d-flex align-items-center justify-content-center",
                            maxWidth: 180,
                        },
                        {
                            id: "dateModified",
                            Header: 'Last Modified',
                            accessor: 'dateModified',
                            className: "d-flex align-items-center justify-content-center",
                            Cell: (props) => <div><span data-tip={convertToApproximateDateString(props.value)}>{convertToDateTimeString(props.value)}</span><ReactTooltip /></div>,
                            maxWidth: 180,
                        },
                        {
                            id: "version",
                            Header: 'Version',
                            accessor: 'version',
                            className: "d-flex align-items-center justify-content-center",
                            maxWidth: 190,
                        },
                        {
                            id: "create",
                            Header: "",
                            className: "d-flex align-items-right",
                            maxWidth: 150,
                            style: { textAlign: 'right' },
                            Cell: row => (
                                <div>
                                    <button disabled={!hasPermission}
                                        onClick={
                                            (e) => {
                                                e.stopPropagation();
                                                console.log(row)
                                                setEditModelViewState(true, row.original.collectionInstanceId, row.original.formTemplate.name + " [" + row.original.version + "]", row.original.formTemplate.description)
                                            }
                                        }
                                        type="button"
                                        className="btn btn-outline-secondary mr-2 btn-sm btn-row-version"
                                    >
                                        <span>Open Form</span>
                                    </button>
                                    <button disabled={!hasPermission}
                                        onClick={
                                            (e) => {
                                                e.stopPropagation();
                                                console.log(row)
                                                const url: string = "/trials/" + row.original.trialId + "/forms/" + row.original.id;
                                                this.props.navigate(url);
                                            }
                                        }
                                        type="button"
                                        className="btn btn-outline-secondary mr-2 btn-sm btn-row-version"
                                    >
                                        <span>Edit</span>
                                    </button>
                                </div>
                            )
                        }
                    ]}
                />
            </div>
        </>
    }

    renderItemModal() {
        const {
            editModalOpen,
            setEditModelViewState,
            collectionInstanceId,
            loadTrialForm,
            trialFormId,
            trialId,
            modalTitle,
            modalDescription,
            permissions,
            savingTrialForm,
            form,
            formState
        } = this.props

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialFormUpdate, Dtos.Permission.TrialFormCreate);
        const formDisabled: boolean = !hasPermission || savingTrialForm || (formState && formState.formStatus == Dtos.FormStatus.Disabled);


        if (collectionInstanceId && collectionInstanceId > 0) {
            return <Modal
                open={editModalOpen}
                disableCloseOnOverlayClick={true}
                onClose={() => {
                    setEditModelViewState(false, null, "", "");
                    loadTrialForm(trialFormId);
                }}
                size={ModalSize.Xl}>
                <div className="modal-header">
                    <h5 className="modal-title">{setModalTitle(undefined, modalTitle)}{modalDescription ? <><br /><small style={{ color: '#444' }}>{modalDescription}</small></> : undefined}</h5>
                    <button type="button" className="close" aria-label="Close" onClick={() => {
                        setEditModelViewState(false, null, "", "");
                        loadTrialForm(trialFormId);
                    }}>
                        <FontAwesomeIcon fixedWidth icon={FontAwesomeIcons.Regular.TIMES} />
                    </button>

                </div>
                <div className="modal-body">
                    <CollectionInstancePage
                        readonly={formDisabled}
                        collectionInstanceId={collectionInstanceId}
                        onClose={() => {
                            setEditModelViewState(false, null, "", "");
                            loadTrialForm(trialFormId);
                        }} />
                </div>
            </Modal>
        }
    }


    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
        </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.TrialForm) {
        const {
            saveTrialForm
        } = this.props;

        if (data) {
            let changes: Dtos.TrialForm = {} as Dtos.TrialForm;
            saveTrialForm(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(data: Dtos.Trial) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            trialId,
            navigate
        } = this.props;

        navigate("/trials/" + trialId + "/forms");
    }

    loadForm() {
        const {
            loadForm,
            trialForm,
        } = this.props

        let extraData: Dtos.TrialForm = {} as Dtos.TrialForm;

        loadForm(reduxFormName, Object.assign({ ...trialForm }, extraData));
    }
}


const mapStateToProps = (state: ITmdState, ownProps: TrialFormPageProps): ITrialFormPageProps => {

    let trialForm: Dtos.TrialForm | undefined = !(state.trialForm.formData instanceof Array) ? state.trialForm.formData : undefined;
    let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
        trialFormId: ownProps.match && ownProps.match.params.trialFormId.toString() != "create" ? ownProps.match.params.trialFormId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        trialForm: trialForm!,

        trial: trial!,

        modalTitle: state.trialFormsPage.name,
        modalDescription: state.trialFormsPage.description,

        editModalOpen: state.trialFormsPage.editModalOpen,
        collectionInstanceId: state.trialFormsPage.collectionInstanceId,

        createVersionModalOpen: state.trialFormsPage.createVersionModalOpen,


        loadingTrialForm: state.trialForm.loadState && state.trialForm.loadState.status == RequestState.Pending,
        loadTrialFormSuccess: state.trialForm.loadState && state.trialForm.loadState.status == RequestState.Success,
        loadTrialFormFailure: state.trialForm.loadState && state.trialForm.loadState.status == RequestState.Failure,

        savingTrialForm: state.trialForm.saveState && state.trialForm.saveState.status == RequestState.Pending,
        saveTrialFormSuccess: state.trialForm.saveState && state.trialForm.saveState.status == RequestState.Success,
        saveTrialFormFailure: state.trialForm.saveState && state.trialForm.saveState.status == RequestState.Failure,

        creatingTrialForm: state.trialForm.createState && state.trialForm.createState.status == RequestState.Pending,
        createTrialFormSuccess: state.trialForm.createState && state.trialForm.createState.status == RequestState.Success,
        createTrialFormFailure: state.trialForm.createState && state.trialForm.createState.status == RequestState.Failure,

        loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,

        user: state.user.data,
        permissions: permissions,
        lookups: state.trialForm.lookups,

        form: state.reduxForms.trialForm,
        formState: state.trialForm.formState,
        formProperties: state.trialForm.formProperties,

        reduxFormState: state.reduxForms.formState.trialForm,
        validationFailures: trialForm ?
            state.trialForm.validationFailures :
            undefined,

    };
};

const mapDispatchToProps = (dispatch): ITrialFormPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadTrialForm: bindActionCreators(TrialFormActions.LoadTrialFormById, dispatch),
        clearTrialForm: bindActionCreators(TrialFormActions.Clear, dispatch),
        createTrialForm: bindActionCreators(TrialFormActions.CreateTrialForm, dispatch),
        saveTrialForm: bindActionCreators(TrialFormActions.SaveTrialForm, dispatch),
        sendReminderEmailTrialForm: bindActionCreators(TrialFormActions.SendReminderEmail, dispatch),

        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch),

        setEditModelViewState: bindActionCreators(TrialFormsPageActions.setEditModalViewState, dispatch),
        setCreateVersionModelViewState: bindActionCreators(TrialFormsPageActions.setCreateVersionModalViewState, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TrialFormPage);
